import React, { useMemo, memo } from "react";
import { Row, Col, Container } from "react-bootstrap";
import "../styles/Skills.css";
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaMobileAlt, FaGitAlt, FaBrush, FaBolt, FaSearch } from "react-icons/fa";
import { SiNextdotjs, SiTailwindcss, SiBootstrap } from "react-icons/si";
import useScrollAnimation from "../hooks/useScrollAnimation";

const SKILLS_DATA = [
  { name: "HTML", Icon: FaHtml5 },
  { name: "CSS", Icon: FaCss3Alt },
  { name: "JavaScript", Icon: FaJs },
  { name: "React.js", Icon: FaReact },
  { name: "Responsive Design", Icon: FaMobileAlt },
  { name: "Tailwind CSS", Icon: SiTailwindcss },
  { name: "Styled Components", Icon: FaBrush },
  { name: "Bootstrap", Icon: SiBootstrap },
  { name: "Git & Github", Icon: FaGitAlt },
  { name: "Framer Motion", Icon: FaBolt },
  { name: "Next.js", Icon: SiNextdotjs },
  { name: "SEO Best Practices", Icon: FaSearch }
];

const SKILLS_ROWS = [];
for (let i = 0; i < SKILLS_DATA.length; i += 4) {
  SKILLS_ROWS.push(SKILLS_DATA.slice(i, i + 4));
}

const SkillCard = memo(function SkillCard({ name, Icon }) {
  return (
    <Col xs={6} sm={6} md={3} className="d-flex justify-content-center position-relative mb-4">
      <div className="icon_wrapper"><Icon /></div>
      <div className="skill-box">
        <div className="animated-border"></div>
        <div className="skill-name">{name}</div>
      </div>
    </Col>
  );
});

const Skills = memo(function Skills() {
  const [titleRef, animate] = useScrollAnimation();
  const title = "My Skills";

  const animatedTitle = useMemo(
    () =>
      title.split("").map((char, i) => (
        <span
          key={i}
          style={{ animationDelay: `${i * 0.08}s` }}
          className="animated-char"
        >
          {char === " " ? "\u00A0" : char}
        </span>
      )),
    [title]
  );

  return (
    <section className="skills-section">
      <Container className="skills-container">
        <h2 ref={titleRef} className={`animated-title ${animate ? "show" : ""}`}>
          {animatedTitle}
        </h2>
        {SKILLS_ROWS.map((row, idx) => (
          <Row key={idx} className="justify-content-center mt-4 ">
            {row.map(({ name, Icon }) => (
              <SkillCard key={name} name={name} Icon={Icon} />
            ))}
          </Row>
        ))}
      </Container>
    </section>
  );
});

export default Skills;
